import { gsap, Power1 } from "gsap";
const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

document.addEventListener('DOMContentLoaded', () => {

    const nav = document.getElementsByClassName('js-nav')[0],
          hamburger = document.getElementsByClassName('js-hamburger')[0],
          menu = document.getElementsByClassName('js-menu')[0],
          menu_item = menu.getElementsByTagName('li');

    const init = function() {

        window.hideMenu = function() {
            if ( nav.classList.contains('is-animated') ) {
                document.querySelector('.js-nav').classList.remove('is-visible');
                document.querySelector('.js-hamburger').classList.remove('is-active');
                
                document.removeEventListener('click', clickOutside);
                document.documentElement.classList.remove('mobile-menu');
                
                setTimeout(function() {
                    document.querySelector('.js-nav').classList.remove('is-block', 'is-animated');
                }, 400);
                
                if (window.innerWidth <= 1140) {
                    enableBodyScroll(document.getElementsByClassName('js-menu')[0]);
                }
            }            
        };

        const showMenu = function() {
            
            nav.classList.add('is-block');
            hamburger.classList.add('is-active');
            document.documentElement.classList.add('mobile-menu');

            setTimeout(function() {
                nav.classList.add('is-visible');
                document.addEventListener('click', clickOutside);
                showLinks();
            }, 100);    
            
            const showLinks = function() {
                gsap.utils.toArray(".js-menu").forEach(function(elem) {            
                    const blocks = elem.querySelectorAll("nav > ul > li"),
                          tl = gsap.timeline().delay(.2).eventCallback("onComplete", function() {
                              nav.classList.add('is-animated');
                          })

                    .from(blocks, {
                        x: -60,
                        duration: .8,
                        opacity: 0,
                        stagger: {
                            each: 0.1
                        },
                        ease: 'elastic.out(1, .8)',
                    });
                });
            };        

            if (window.innerWidth <= 1024) {
                disableBodyScroll(menu);
            }
        };

        // Submenu
        
        const submenu = (e)=> {
            if (window.innerWidth <= 768) {
                let item = e.currentTarget;
                
                //if(!item.classList.contains('lang')) {
                    e.stopPropagation();
                    e.preventDefault() ? e.preventDefault() : e.preventDefault = false;

                    if (item.classList.contains('parent')) {
                        item.classList.contains('is-open') ? item.classList.remove('is-open') : item.classList.add('is-open');
                    } else {
                        let url = item.getElementsByTagName('a')[0].getAttribute('href');
                        window.open(url, '_self');
                        hideMenu();
                    }
                //}
            }
        }
        
        for (let j = 0; j < menu_item.length; j++) {
            menu_item[j].addEventListener('click', submenu);
        }

        const toggleMenu = function(e) {
            nav.classList.contains('is-visible') ? hideMenu() : showMenu();
        };
        
        const clickOutside = function(e) {
            if (!e.target.closest('.js-nav')) {
                hideMenu();
        	}
        };
        

        // Click event
        
/*
        for (let j = 0; j < menu_item.length; j++) {
            menu_item[j].addEventListener('click', submenu);
        }
*/

        hamburger.addEventListener('click', toggleMenu);

        // Hide menu on ESC

        document.addEventListener('keydown', function(evt) {
            // evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key == "Escape" || evt.key == "Esc");
            } else {
                isEscape = (evt.keyCode == 27);
            }
            if (isEscape) {
                hideMenu();
            }
        });
        
        
        const checkWindowSize = function() {
            
            if (window.innerWidth > 1100) {
                hideMenu();
                window.removeEventListener('resize', checkWindowSize);
            }
        };
        
        
        window.addEventListener('resize', checkWindowSize);

    };

    nav ? init() : false;

}, false);